/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import {
  Document,
  Font,
  Image,
  Page,
  Path,
  PDFDownloadLink,
  StyleSheet,
  Svg,
  Text,
  View,
} from "@react-pdf/renderer";

import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";
import LatoBold from "../../font/Lato-Bold.ttf";
import LatoBlack from "../../font/Lato-Black.ttf";
import Museo700 from "../../font/Museo700-Regular.ttf";
import Museo300 from "../../font/Museo300-Regular.ttf";
import everDrivenHeroWave from "../../Assets/everDrivenHeroWave.png";
import {
  everDrivenInspectionPointColumns,
  everDrivenLogoUrl,
  formatEverDrivenDate,
  getEverDrivenFullName,
  getEverDrivenInspectorName,
  getVinCells,
  handDrawnCirclePath,
  humanTickPaths,
  normalizeEverDrivenValue,
} from "./certificateData";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });
Font.register({ family: "LatoBold", format: "truetype", src: LatoBold });
Font.register({ family: "LatoBlack", format: "truetype", src: LatoBlack });
Font.register({ family: "Museo", format: "truetype", src: Museo700 });
Font.register({ family: "MuseoLight", format: "truetype", src: Museo300 });

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    color: "#0d2c6c",
    fontFamily: "Helvetica",
    paddingBottom: 6,
  },
  hero: {
    height: 96,
    position: "relative",
  },
  heroBg: {
    height: "100%",
    left: 0,
    objectFit: "fill",
    position: "absolute",
    top: 0,
    width: "100%",
  },
  heroContent: {
    alignItems: "center",
    flexDirection: "row",
    height: 72,
    justifyContent: "center",
  },
  logo: {
    height: 31,
    objectFit: "contain",
    width: 132,
  },
  heroDivider: {
    backgroundColor: "#0d2c6c",
    height: 40,
    marginHorizontal: 24,
    width: 1.4,
  },
  heroTitle: {
    color: "#0d2c6c",
    fontFamily: "LatoBold",
    fontSize: 23,
    lineHeight: 1,
  },
  content: {
    marginHorizontal: 38,
    marginTop: 8,
  },
  sectionTitle: {
    alignItems: "center",
    borderRadius: 4,
    color: "#fff",
    flexDirection: "row",
    justifyContent: "center",
    paddingVertical: 6,
  },
  sectionTitleBlue: {
    backgroundColor: "#123372",
    marginTop: 12,
  },
  sectionTitleGreen: {
    backgroundColor: "#61c4b0",
    marginTop: 8,
  },
  sectionTitleStrong: {
    color: "#fff",
    fontFamily: "LatoBold",
    fontSize: 14,
  },
  sectionTitleText: {
    color: "#fff",
    fontSize: 9,
    marginLeft: 6,
  },
  driverGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 8,
  },
  field: {
    marginBottom: 5,
  },
  fieldHalfLeft: {
    marginRight: 10,
    width: 250,
  },
  fieldHalfRight: {
    width: 250,
  },
  fieldThird: {
    marginRight: 10,
    width: 160,
  },
  fieldThirdLast: {
    width: 160,
  },
  fieldLabel: {
    color: "#0d2c6c",
    fontFamily: "Museo",
    fontSize: 9,
    marginBottom: 1,
    minHeight: 10,
  },
  fieldLine: {
    borderBottomColor: "#4a759a",
    borderBottomStyle: "dotted",
    borderBottomWidth: 1,
    color: "#000000",
    fontSize: 11,
    lineHeight: 1,
    minHeight: 12,
    paddingBottom: 1,
  },
  vinBoxes: {
    flexDirection: "row",
    minHeight: 12,
  },
  vinCell: {
    alignItems: "center",
    borderBottomColor: "#4a759a",
    borderBottomStyle: "dotted",
    borderBottomWidth: 1,
    borderRightColor: "#4a759a",
    borderRightStyle: "dotted",
    borderRightWidth: 1,
    color: "#000000",
    fontSize: 8.5,
    justifyContent: "flex-end",
    paddingBottom: 1,
    textAlign: "center",
    width: 14.7,
  },
  vinCellFirst: {
    borderLeftColor: "#4a759a",
    borderLeftStyle: "dotted",
    borderLeftWidth: 1,
  },
  inspectionGrid: {
    flexDirection: "row",
    marginTop: 6,
  },
  inspectionColumnLeft: {
    marginRight: 18,
    width: 270,
  },
  inspectionColumnRight: {
    width: 250,
  },
  inspectionHeader: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 2,
  },
  inspectionHeaderLabel: {
    color: "#0d2c6c",
    flex: 1,
    fontFamily: "LatoBold",
    fontSize: 10,
  },
  inspectionHeaderOption: {
    color: "#0d2c6c",
    fontFamily: "LatoBold",
    fontSize: 10,
    textAlign: "center",
    width: 35,
  },
  inspectionRow: {
    alignItems: "center",
    flexDirection: "row",
    minHeight: 12,
  },
  inspectionLabel: {
    color: "#0d2c6c",
    flex: 1,
    fontSize: 8.8,
  },
  inspectionOption: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    width: 35,
  },
  bracket: {
    color: "#000000",
    fontFamily: "LatoBold",
    fontSize: 10,
    lineHeight: 1,
  },
  tickWrap: {
    height: 11,
    position: "relative",
    width: 11,
  },
  humanTick: {
    height: 14,
    left: -1.5,
    position: "absolute",
    top: -1.5,
    width: 14,
  },
  resultBox: {
    borderColor: "#61c4b0",
    borderRadius: 4,
    borderWidth: 1,
    flexDirection: "row",
    marginTop: 7,
  },
  resultLabel: {
    justifyContent: "center",
    minHeight: 36,
    paddingHorizontal: 12,
    width: 112,
  },
  resultLabelStrong: {
    color: "#0d2c6c",
    fontFamily: "LatoBold",
    fontSize: 10,
  },
  resultLabelText: {
    color: "#0d2c6c",
    fontSize: 9,
    marginTop: 2,
  },
  resultCell: {
    alignItems: "center",
    borderLeftColor: "#61c4b0",
    borderLeftWidth: 1,
    justifyContent: "center",
    minHeight: 36,
    position: "relative",
    width: 70,
  },
  resultCellText: {
    color: "#000000",
    fontFamily: "LatoBold",
    fontSize: 10,
    position: "relative",
  },
  resultCircle: {
    height: 39,
    left: 8,
    position: "absolute",
    top: 0,
    width: 54,
  },
  footerFields: {
    borderTopColor: "#4a759a",
    borderTopWidth: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 5,
    paddingTop: 4,
  },
  footerField: {
    marginBottom: 4,
  },
  footerFieldLabel: {
    color: "#0d2c6c",
    fontFamily: "Museo",
    fontSize: 9,
    marginBottom: 1,
  },
  footerFieldNote: {
    fontFamily: "MuseoLight",
    fontSize: 7,
  },
  footerFieldLabelWrap: {
    minHeight: 12,
    justifyContent: "flex-end",
  },
  footerFieldLine: {
    borderBottomColor: "#4a759a",
    borderBottomStyle: "dotted",
    borderBottomWidth: 1,
    color: "#000000",
    fontSize: 11,
    lineHeight: 1,
    minHeight: 12,
    paddingBottom: 1,
  },
  signatureLine: {
    alignItems: "flex-end",
    borderBottomColor: "#4a759a",
    borderBottomStyle: "dotted",
    borderBottomWidth: 1,
    flexDirection: "row",
    minHeight: 11,
    position: "relative",
  },
  signatureText: {
    color: "#000000",
    fontSize: 11,
    lineHeight: 1,
  },
  signatureImage: {
    bottom: -8,
    height: 34,
    position: "absolute",
    right: 0,
    width: 120,
  },
  disclaimer: {
    color: "#0d2c6c",
    fontSize: 5.5,
    lineHeight: 1.05,
    marginHorizontal: 38,
    marginTop: 8,
  },
  pageFooter: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 38,
    marginTop: 7,
  },
  copyright: {
    color: "#4a759a",
    fontSize: 8,
  },
  website: {
    color: "#0d2c6c",
    fontFamily: "LatoBlack",
    fontSize: 10,
  },
});

const Field = ({
  label,
  value,
  style,
  handwritingStyle,
  labelStyle,
  lineStyle,
}) => (
  <View style={[styles.field, style].filter(Boolean)}>
    <Text style={[styles.fieldLabel, labelStyle].filter(Boolean)}>{label}</Text>
    <Text style={[styles.fieldLine, lineStyle, handwritingStyle].filter(Boolean)}>
      {value || ""}
    </Text>
  </View>
);

const FooterField = ({ label, value, style, handwritingStyle }) => (
  <View style={[styles.field, styles.footerField, style].filter(Boolean)}>
    <View style={styles.footerFieldLabelWrap}>
      <Text style={styles.footerFieldLabel}>{label}</Text>
    </View>
    <Text
      style={[styles.fieldLine, styles.footerFieldLine, handwritingStyle].filter(Boolean)}
    >
      {value || ""}
    </Text>
  </View>
);

const VinField = ({ value, handwritingStyle }) => (
  <View style={[styles.field, styles.fieldHalfRight]}>
    <Text style={styles.fieldLabel}>VIN</Text>
    <View style={styles.vinBoxes}>
      {getVinCells(value).map((char, index) => (
        <Text
          style={[
            styles.vinCell,
            index === 0 && styles.vinCellFirst,
            handwritingStyle,
          ].filter(Boolean)}
          key={index}
        >
          {char}
        </Text>
      ))}
    </View>
  </View>
);

const HumanTick = ({ tickIndex = 0 }) => (
  <Svg style={styles.humanTick} viewBox="0 0 24 24">
    <Path
      d={humanTickPaths[tickIndex % humanTickPaths.length]}
      stroke="#000000"
      strokeWidth={2.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Svg>
);

const BracketCheck = ({ checked, tickIndex }) => (
  <View style={styles.inspectionOption}>
    <Text style={styles.bracket}>[</Text>
    <View style={styles.tickWrap}>
      {checked ? <HumanTick tickIndex={tickIndex} /> : null}
    </View>
    <Text style={styles.bracket}>]</Text>
  </View>
);

const InspectionRow = ({ item }) => (
  <View style={styles.inspectionRow}>
    <Text style={styles.inspectionLabel}>
      {item.number}. {item.label}
    </Text>
    <BracketCheck checked tickIndex={item.number} />
    <BracketCheck checked={false} tickIndex={item.number + 2} />
  </View>
);

const HandDrawnCircle = () => (
  <Svg style={styles.resultCircle} viewBox="0 0 112 73">
    <Path
      d={handDrawnCirclePath}
      stroke="#000000"
      strokeWidth={5}
      strokeLinecap="round"
      fill="none"
    />
  </Svg>
);

const ResultCell = ({ active, children }) => (
  <View style={styles.resultCell}>
    {active ? <HandDrawnCircle /> : null}
    <Text style={styles.resultCellText}>{children}</Text>
  </View>
);

const EverDrivenCertificateDownload = ({
  reportData,
  handwritingFont = "kalamFont",
  fileName = "EverDriven-Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) => {
  const handwritingStyle = { fontFamily: handwritingFont };
  const finalStatus = normalizeEverDrivenValue(reportData?.finalStatus);
  const inspectorName = getEverDrivenInspectorName(reportData);

  return (
    <div className="App">
      <PDFDownloadLink
        document={
          <Document>
            <Page size="A4" style={styles.page} wrap={false}>
              <View style={styles.hero}>
                <Image src={everDrivenHeroWave} style={styles.heroBg} />
                <View style={styles.heroContent}>
                  <Image style={styles.logo} source={`${everDrivenLogoUrl}?x-request=xhr`} />
                  <View style={styles.heroDivider} />
                  <Text style={styles.heroTitle}>California Vehicle Inspection</Text>
                </View>
              </View>

              <View style={styles.content}>
                <View style={[styles.sectionTitle, styles.sectionTitleBlue]}>
                  <Text style={styles.sectionTitleStrong}>EverSafe Driver Info</Text>
                  <Text style={styles.sectionTitleText}>(All fields are mandatory)</Text>
                </View>

                <View style={styles.driverGrid}>
                  <Field
                    label="Driver Name"
                    value={getEverDrivenFullName(reportData)}
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Service Provider"
                    value={reportData?.CompanyData?.name || "EverDriven"}
                    style={styles.fieldHalfRight}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Phone Number"
                    value={reportData?.Userphone}
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Email"
                    value={reportData?.Useremail}
                    style={styles.fieldHalfRight}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Year"
                    value={reportData?.year}
                    style={styles.fieldThird}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Make"
                    value={reportData?.make}
                    style={styles.fieldThird}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="Vehicle Model"
                    value={reportData?.model}
                    style={styles.fieldThirdLast}
                    handwritingStyle={handwritingStyle}
                  />
                  <Field
                    label="License Plate #"
                    value={reportData?.licensePlateNumber}
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <VinField value={reportData?.vin} handwritingStyle={handwritingStyle} />
                </View>

                <View style={[styles.sectionTitle, styles.sectionTitleGreen]}>
                  <Text style={styles.sectionTitleStrong}>Vehicle Inspection</Text>
                  <Text style={styles.sectionTitleText}>
                    (To be completed by Inspector only. All fields are mandatory)
                  </Text>
                </View>

                <View style={styles.inspectionGrid}>
                  <View style={styles.inspectionColumnLeft}>
                    <View style={styles.inspectionHeader}>
                      <Text style={styles.inspectionHeaderLabel}>Inspection Point</Text>
                      <Text style={styles.inspectionHeaderOption}>Pass</Text>
                      <Text style={styles.inspectionHeaderOption}>Fail</Text>
                    </View>
                    {everDrivenInspectionPointColumns[0].map((item) => (
                      <InspectionRow item={item} key={item.number} />
                    ))}
                  </View>

                  <View style={styles.inspectionColumnRight}>
                    <View style={styles.inspectionHeader}>
                      <Text style={styles.inspectionHeaderLabel}> </Text>
                      <Text style={styles.inspectionHeaderOption}>Pass</Text>
                      <Text style={styles.inspectionHeaderOption}>Fail</Text>
                    </View>
                    {everDrivenInspectionPointColumns[1].map((item) => (
                      <InspectionRow item={item} key={item.number} />
                    ))}

                    <View style={styles.resultBox}>
                      <View style={styles.resultLabel}>
                        <Text style={styles.resultLabelStrong}>Vehicle Inspection</Text>
                        <Text style={styles.resultLabelText}>(Please circle one)</Text>
                      </View>
                      <ResultCell active={finalStatus === "pass"}>PASS</ResultCell>
                      <ResultCell active={finalStatus === "fail"}>FAIL</ResultCell>
                    </View>
                  </View>
                </View>

                <View style={styles.footerFields}>
                  <FooterField
                    label="Name of BAR Shop"
                    value="Chex Inc."
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <FooterField
                    label="BAR License Number"
                    value={reportData?.stateNumber}
                    style={styles.fieldHalfRight}
                    handwritingStyle={handwritingStyle}
                  />
                  <FooterField
                    label="BAR Shop Address"
                    value={reportData?.stateAddress}
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <FooterField
                    label={
                      <>
                        Inspection Date{" "}
                        <Text style={styles.footerFieldNote}>
                          (Document expires one year from this date)
                        </Text>
                      </>
                    }
                    value={formatEverDrivenDate(reportData?.reviewedDate)}
                    style={styles.fieldHalfRight}
                    handwritingStyle={handwritingStyle}
                  />
                  <FooterField
                    label="Vehicle Mileage from Odometer"
                    value={reportData?.milage}
                    style={styles.fieldHalfLeft}
                    handwritingStyle={handwritingStyle}
                  />
                  <View style={[styles.field, styles.footerField, styles.fieldHalfRight]}>
                    <View style={styles.footerFieldLabelWrap}>
                      <Text style={styles.footerFieldLabel}>Inspector Name and Signature</Text>
                    </View>
                    <View style={styles.signatureLine}>
                      <Text style={[styles.signatureText, handwritingStyle]}>
                        {inspectorName}
                      </Text>
                      {reportData?.Inspectorsignature ? (
                        <Image
                          style={styles.signatureImage}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${reportData.Inspectorsignature}?x-request=xhr`}
                        />
                      ) : null}
                    </View>
                  </View>
                </View>
              </View>

              <Text style={styles.disclaimer}>
                Applicants who do not match the photo on their driver's license or do not have the proper documents,
                cannot complete an inspection. Failing inspections can only be remedied by the same shop on the same day.
                If an applicant fails the inspection and is unable to fix the issues on the spot, a new appointment must be made,
                and a new inspection form must be used. This inspection form reflects a 19 point inspection only on the date of
                the inspection listed above. For purposes of this inspection, the wheels were not removed from the vehicle,
                and the vehicle was not put on a lift, nor was it checked for emissions.
              </Text>

              <View style={styles.pageFooter}>
                <Text style={styles.copyright}>{"\u00A9"}2024 EverDriven. All Rights Reserved</Text>
                <Text style={styles.website}>everdriven.com</Text>
              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ loading }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "20px",
                }}
              >
                {linkLabel}
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
};


const EverDrivenCertificateDownloadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template2");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <EverDrivenCertificateDownload
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.vehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setOtherReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EverDrivenCertificateDownloadConnected);
